module.exports = __webpack_public_path__ + "static/media/ZIYUAN 1-02C (ZY 1-02C).687b9997.czml";